<template>
  <Header />
  <div class="container faqe">
    <h4 class="page-title" style="padding: 2rem; font-weight: bold">
      マイアカウントの管理
    </h4>
    <div class="estimation-container point">
      <section
        style="
          display: flex;
          justify-content: flex-start;
          padding-bottom: 0.5rem;
        "
      >
        <b>ポイント</b>
      </section>
      <div style="text-align: start">
        <p style="color: #595959">
          DSP配信で設定した予算の残高がポイントに加算されます
        </p>
        <section style="display: flex; justify-content: space-between">
          <div style="display: flex; align-items: center; gap: 0.5rem">
            <img src="../assets/img/star.svg" alt="" srcset="" />
            <b style="color: #95c41c">ポイント</b>
          </div>
          <div style="color: #95c41c">
            <b>{{ myAccount().points?.toLocaleString() }}</b>
          </div>
        </section>
      </div>
    </div>
    <div class="h-table">
      <div class="grid-list header">
        <b>日付</b>
        <b>ステータス</b>
        <b>オーダー</b>
        <b>獲得／使用ポイント</b>
      </div>
      <div class="grid-list" v-for="point in pointHistory" key="point">
        <div style="padding: 1rem 0;">{{ point?.created_at }}</div>
        <div style="padding: 1rem 0;">
          <div
            v-if="point?.action_name == 'sub'"
            style="
              border: 1px solid #cd0000;
              color: #cd0000;
              width: max-content;
              padding: 0.3rem 0.8rem;
              border-radius: 20px;
              background-color: #ffe9e9;
            "
          >
            消費
          </div>
          <div
            v-else-if="point?.action_name == 'exp'"
            style="
              border: 1px solid #595959;
              color: #595959;
              width: max-content;
              padding: 0.3rem 0.8rem;
              border-radius: 20px;
              background-color: #ebebeb;
            "
          >
            消滅
          </div>
          <div
            v-else
            style="
              border: 1px solid #23a047;
              color: #23a047;
              width: max-content;
              padding: 0.3rem 0.8rem;
              border-radius: 20px;
              background-color: #eefff3;
            "
          >
            発行
          </div>
        </div>
        <div style="padding: 1rem 0;">{{ point?.order_key }}</div>
        <div style="padding: 1rem 0;">
          <div
            v-if="point?.action_name == 'sub'"
            style="padding: 0rem 0; color: #cd0000"
          >
            {{ point?.amount?.toLocaleString() }}
          </div>
          <div
            v-else-if="point?.action_name == 'exp'"
            style="padding: 0rem 0; color: #595959"
          >
            {{ point?.amount?.toLocaleString() }}
          </div>
          <div v-else style="padding: 0rem 0; color: #23a047">
            {{ point?.amount?.toLocaleString() }}
          </div>
        </div>
      </div>
      <table style="width: 100%; margin-top: 2rem; display: none">
        <thead style="text-align: start">
          <tr>
            <th style="padding: 1rem 0">日付</th>
            <th style="padding: 1rem 0">ステータス</th>
            <th style="padding: 1rem 0">オーダー</th>
            <th style="padding: 1rem 0">獲得／使用ポイント</th>
          </tr>
        </thead>
        <tbody style="text-align: start">
          <tr
            v-for="point in pointHistory"
            key="point"
            style="border-top: 1px solid #c4c4c4"
          >
            <td style="padding: 1rem 0">{{ point?.created_at }}</td>
            <td style="padding: 1rem 0">
              <div
                v-if="point?.action_name == 'sub'"
                style="
                  border: 1px solid #cd0000;
                  color: #cd0000;
                  width: max-content;
                  padding: 0.3rem 0.8rem;
                  border-radius: 20px;
                  background-color: #ffe9e9;
                "
              >
                消費
              </div>
              <div
                v-else-if="point?.action_name == 'exp'"
                style="
                  border: 1px solid #595959;
                  color: #595959;
                  width: max-content;
                  padding: 0.3rem 0.8rem;
                  border-radius: 20px;
                  background-color: #ebebeb;
                "
              >
                消滅
              </div>
              <div
                v-else
                style="
                  border: 1px solid #23a047;
                  color: #23a047;
                  width: max-content;
                  padding: 0.3rem 0.8rem;
                  border-radius: 20px;
                  background-color: #eefff3;
                "
              >
                発行
              </div>
            </td>
            <td style="padding: 1rem 0">{{ point?.order_key }}</td>
            <td
              v-if="point?.action_name == 'sub'"
              style="padding: 1rem 0; color: #cd0000"
            >
              {{ point?.amount?.toLocaleString() }}
            </td>
            <td
              v-else-if="point?.action_name == 'exp'"
              style="padding: 1rem 0; color: #595959"
            >
              {{ point?.amount?.toLocaleString() }}
            </td>
            <td v-else style="padding: 1rem 0; color: #23a047">
              {{ point?.amount?.toLocaleString() }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import backendApi from "../apis/backend-api";
import Header from "../components/Header.vue";
import { accountStore } from "../store/account-store";
export default {
  name: "PointLists",
  components: {
    Header,
  },
  data() {
    return {
      accountStore,
      pointHistory: [],
    };
  },
  async created() {
    const pointResp = await backendApi.pointHistory();
    if (pointResp.result == "success") {
      this.pointHistory = pointResp.value;
      console.log(this.pointHistory);
    }
  },
  methods: {
    myAccount() {
      // console.log(this.accountStore.getters.myAccount);
      return this.accountStore.getters.myAccount;
    },
  },
};
</script>

<style lang="scss" scoped>
.faqe {
  overflow: auto;
  // background-color: red;
  height: 100vh;
}
.estimation-container {
  overflow: auto;
  margin-top: 10px;
  border: 1px solid #cd0000;
  padding: 10px 15px;
  color: #cd0000;
  width: 340px;
  &.point {
    color: #000;
    border: 1px solid #c4c4c4;
    background-color: #95c41c4d;
  }
}
.h-table {
  // background-color: red;
  height: calc(100dvh - 320px);
  overflow: auto;
  .grid-list {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    text-align: left;
    &.header {
      position: sticky;
      top: 0;
      background-color: #fff;
      padding: 1rem 0;
    }
  }
}
</style>
